import './App.css';
import Header from './components/hd';
import Footer from './components/ft';
import Home from './pages/home.js';
import About from './pages/about';
import Services from './pages/ourservices';
import Contact from './pages/contactus';
import Latestnews from './pages/latestnews';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';

function App() {
  
  const Layout =()=>{
    return(
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  }
  
  return (
    <>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="ourservices" element={<Services />} />
              <Route path="latestnews" element={<Latestnews />} />
              <Route path="contactus" element={<Contact />} />
            </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;
